import { ApolloLink } from '@apollo/client'
import { Observable } from '@apollo/client/utilities'
import { dataHasError } from '../../components/responses/dataHasError'
import { createUnauthorizedError } from '../graphql-client'

// Cases where the backend returns 200 OK but includes auth errors in the response
// For example TowingRecord query may return 200 OK but include UnauthorizedError in data
export const createAuthCheckLink = () =>
  new ApolloLink((operation, forward) =>
    new Observable(observer => {
      if (!forward) {
        observer.complete();
        return;
      }
      forward(operation).subscribe({
        next: (response) => {
          if (!response.data || operation.operationName === 'loginClientState') {
            observer.next(response)
            return
          }

          if (dataHasError(response.data, 'UnauthorizedError')) {
            const graphqlError = createUnauthorizedError()
            observer.next({
              ...response,
              errors: [...(response.errors || []), graphqlError],
            })
            return
          }

          observer.next(response)
        },
        error: (error) => observer.error(error),
        complete: () => observer.complete(),
      })
    })
  )
